var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandingDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.6,24.4c0,1.5,0.7,2.9,2.1,2.9v8.2c0,0.8,0.6,1.6,1.4,1.8c1.1,0.3,2.3-0.3,2.6-1.4 c0-0.2,0.1-0.3,0.1-0.5l0.1-15.9l-2.3-0.8v-0.4l4.7,1.5h5.1c0.2-0.1,0.5-0.2,0.6-0.4c0,0.2-0.1,0.3-0.1,0.5h2.8 c0-0.7-0.6-1.3-1.3-1.3c-0.3,0-0.7,0.1-0.9,0.3c0.1-0.2,0.1-0.5,0.1-0.7c0-0.8-0.6-1.4-1.4-1.4h-4.2l-5.6-2.3 c-0.8-0.2-1.7-0.2-2.5,0.1c-1.4,0.6-1.2,2-1.3,3.4V24.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#505050",
    points: "33.7,18.6 35.1,12.8 35.9,9.3 35.1,9.3 32.7,18.9 33.6,19.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M8.1,34.3v0.5c0.1,1,1,1.8,2,1.8c0.8,0,1.5-0.6,1.7-1.3l0.7-2.5v-5.1c-1.1-0.1-2-1.1-2-2.2L8.1,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M15.4,13.3c1.4-0.9,1.9-2.7,1.1-4.2c-0.9-1.4-2.7-1.9-4.2-1.1c0,0-0.1,0-0.1,0.1c-1.4,0.9-1.8,2.7-1,4.1 C12,13.6,13.9,14.1,15.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.1,20.2h-8.1c-0.2,0-0.4,0.3-0.4,0.5c0,0.2,0.2,0.4,0.4,0.4h3.5l-0.2,0.6h-5.2c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.5,0.4,0.5h5.9l0.4-1.5h2.9v12.2c-1.9,0.1-3.5,1.7-3.4,3.7h7.6c0.1-2-1.4-3.6-3.4-3.8V21h7.4c0.2,0,0.4-0.2,0.4-0.4 c0-0.2-0.2-0.4-0.4-0.4h-3.6v-0.1c0.7,0,1.3-0.5,1.4-1.2l1.1-4.8h-0.3L33.9,19c-0.1,0.5-0.6,0.9-1.1,0.9h-3.8V20.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandingDesk);
export default __webpack_public_path__ + "static/media/standing_desk.5a55b63f44bc6898e4deaa7d501a58c6.svg";
export { ForwardRef as ReactComponent };